import { RouteProps } from 'react-router-dom';
import * as routes from '../../../../../../../common/constants/routes';
import { TestPhoneNumberForm } from './TestPhoneNumberForm/TestPhoneNumberForm';
import { ActivateNumber } from './ActivateNumber/ActivateNumber';
import { PhoneNumberSelection } from './PhoneNumberSelection/PhoneNumberSelection';

export type SettingsSectionDefinition = {
  id: string;
  path: (chatbotId: number) => string;
  component: RouteProps['component'];
};

export const SMS_SECTIONS: SettingsSectionDefinition[] = [
  {
    id: 'number',
    path: routes.SETTINGS_SMS_VIEW_NUMBER_PATH,
    component: TestPhoneNumberForm,
  },
  {
    id: 'area-code-search',
    path: routes.SETTINGS_SMS_AREA_CODE_SEARCH_PATH,
    component: PhoneNumberSelection,
  },
];

export const SMS_SECTIONS_ACTIVE: SettingsSectionDefinition = {
  id: 'activate',
  path: routes.SETTINGS_SMS_ACTIVATE_PATH,
  component: ActivateNumber,
};
